import React from "react";
import './Button.scss';

const Button = (props)=>{

    const { onClick, disabled = false, type, customStyle, label = "Save", title = "" } = props;

    const renderStyle = ()=>{
        switch (type) {
            case 'primary':
                return 'button-primary';
            case 'secondary':
                return 'button-secondary';
            case 'light':
                    return 'button-clear';
            case 'gam':
                    return 'col-icon gam-push-icon-manager'
            default:
                return 'button-primary';
        }
    }

    return (
        <div style={{margin:'0 4px'}}>
         <button title={title} disabled={disabled} className={renderStyle()}  style={{opacity:disabled?0.5:1,...customStyle}}   onClick={onClick}>{label}</button>
        </div>
    )
}
export default Button;